
import {
  Component, PropSync, Prop, Mixins,
} from 'vue-property-decorator';
import { StoreDeletionSteps } from '@/features/ecommerce/views/ECommerce.vue';
import focusMixin from '@/features/common/mixins/focusMixin';

@Component
export default class StoreDeletionModal extends Mixins(focusMixin) {
  protected focusConfirmButtonOnOpen = true;

  @PropSync('show', { required: true }) syncedShow!: boolean;

  @Prop({ required: true }) step!: StoreDeletionSteps;

  @Prop({ default: false }) loading!: boolean

  private steps = StoreDeletionSteps;

  get title(): string {
    if (!this.step) return '';

    return this.$t(`eCommerce.storeDeletion.${this.step.toLowerCase()}.title`) as string;
  }

  get text(): string {
    if (!this.step) return '';

    return this.$t(`eCommerce.storeDeletion.${this.step.toLowerCase()}.text`) as string;
  }

  get btnText(): string {
    if (!this.step) return '';

    return (this.step === this.steps.CONFIRM && this.$t('buttons.delete') as string)
      || (this.step === this.steps.COMPLETED && this.$t('buttons.ok') as string) || '';
  }
}
